import {
    CategoryItemsCount as SourceCategoryItemsCount
} from 'SourceComponent/CategoryItemsCount/CategoryItemsCount.component';

import './CategoryItemsCount.style';

/** @namespace Elganso/Component/CategoryItemsCount/Component */
export class CategoryItemsCountComponent extends SourceCategoryItemsCount {
    // TODO implement logic
    render() {
        return <div className="CategoryItemsCount" />;
    }
}

export default CategoryItemsCountComponent;
